import { Component, Input } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as turf from '@turf/turf';

/**
 * Generated class for the TripImageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'trip-image',
  templateUrl: 'trip-image.html',
})
export class TripImageComponent {
  log = debug('app:TripImageComponent');

  @Input()
  trip;

  polyline: String;

  constructor() {
    this.log('constructed');
  }

  ngOnChanges() {
    const polyline = _.get(this.trip, 'route.properties.polyLine'),
      self = this;

    this.log('route polyline', polyline);

    if (!this.trip._id) {
      // Show defined route when in the trip
      return (this.polyline = polyline);
    }

    if (_.size(this.trip.actualRoute) > 75) {
      this.log('will show actual route', this.trip.actualRoute);
      // this.log(createEncodings(this.trip.actualRoute));
      this.polyline = 'path=enc:' + createEncodings(this.trip.actualRoute);
    } else {
      this.polyline = polyline;
    }

    this.log('line', this.polyline);

    function createEncodings(coords) {
      var i = 0;

      var plat = 0;
      var plng = 0;

      var encoded_points = '';

      let x = 0;

      for (i = 0; i < coords.length; ++i) {
        var lat = coords[i][1];
        var lng = coords[i][0];

        let distance = turf.distance(
          turf.point([plng, plat]),
          turf.point([lng, lat]),
          {
            units: 'miles',
          }
        );

        // decrease how often we draw dots
        if (distance < 1 && _.size(coords) > 500) {
          continue;
        }

        encoded_points += encodePoint(plat, plng, lat, lng);

        x++;
        plat = lat;
        plng = lng;
      }

      self.log('number of points | %s of %s', x, coords.length);
      return encoded_points;
    }

    function encodePoint(plat, plng, lat, lng) {
      var late5 = Math.round(lat * 1e5);
      var plate5 = Math.round(plat * 1e5);

      var lnge5 = Math.round(lng * 1e5);
      var plnge5 = Math.round(plng * 1e5);

      var dlng = lnge5 - plnge5;
      var dlat = late5 - plate5;

      return encodeSignedNumber(dlat) + encodeSignedNumber(dlng);
    }

    function encodeSignedNumber(num) {
      var sgn_num = num << 1;

      if (num < 0) {
        sgn_num = ~sgn_num;
      }

      return encodeNumber(sgn_num);
    }

    function encodeNumber(num) {
      var encodeString = '';

      while (num >= 0x20) {
        encodeString += String.fromCharCode((0x20 | (num & 0x1f)) + 63);
        num >>= 5;
      }

      encodeString += String.fromCharCode(num + 63);
      return encodeString;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/trip-image/trip-image.ts